<!--  搜索结果页   -->
<template>
  <div class="container">
    <div class="search_nav">
      <img class="go_back" src="@/icon/back_black.png" alt @click="go_back()">
      <div class="s_inp">
        <img src="@/assets/icon_search.png" alt="">
        <form action="javascript:return true">
          <input v-model="keyword" type="search" placeholder="搜索课程" @keyup.enter="enter_s()">
        </form>
      </div>
      <div class="ss_btn search_btn" @click="enter_s()">
        搜索
      </div>
      <div class="ss_btn" @click="go_back()">
        取消
      </div>
    </div>
    <div class="res_box">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoreDatas">
        <div v-for="(item,index) in lessonArr" :key="index" class="item_lesson nut-vert-list-item" @click="go_course(item.lesson_id)">
          <img :src="item.thumb" alt="" class="l_img">
          <div class="r_msg">
            <p class="title">{{ item.lesson_name }}</p>
            <div class="cate clearfix">
              <div class="l">
                <img src="@/assets/image/peps.png" alt="">
                <span>{{ item.buy_count }}人学习</span>
              </div>
              <div class="r">
                <img src="@/assets/image/flower.png" alt="">
                <span>{{ item.comment_rate }}好评</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div v-show="is_noway" class="no_res">
        <img src="@/assets/image/wu.png" alt="">
        <p>暂无数据</p></div>
      <div class="hei"></div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tools'
import { getlistlesson } from '@/api/search.js'

export default {
  components: {
    
  },
  inject: ['reload'],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isShow: false,
      refreshing: false,
      page: 1,
      limit: 10,
      lessonArr: [],
      keyword: this.$route.query.search_Value,
      is_noway: false
    }
  },
  computed: {

  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.keyword = this.$route.query.search_Value
        this.lessonArr = []
        this.onLoad()
        this.reload()
      },
      deep: true
    }
  },
  created() {
    this.getCurrentPage()

    this.beforeOnLoad()
    // this.getlist()
  },
  methods: {
    enter_s() {
      var info = {
        content:this.keywords
      }
      saveUserSearchLog(info).then((res)=>{
        if(res.errNo==0){
          this.$router.replace({
            path: '/shopSearch',
            query: {
              keywords: this.keyword
            }
          })
        }
      })
    },
    getMoreDatas() {
      this.onLoad()
    },
    beforeOnLoad() {
      // 注意顺序
      this.lessonArr = []
      this.finished = false
      this.page = this.getCurrentPage()
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      this.page = this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        page: this.page,
        limit: this.limit,
        keyword: this.keyword
      }
      getlistlesson(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.total = result.count
        if (this.page === 1) {
          this.lessonArr = list
        } else {
          this.lessonArr = this.lessonArr.concat(list)
        }
        // 是否 有值显示
        if (this.lessonArr.length > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 是否结束
        if (list.length < this.limit) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    getMoreDatas() {
      this.onLoad()
    },
    getCurrentPage() {
      const count = this.lessonArr.length
      const limit = this.limit
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    getlist() {
      const info = {
        page: this.page,
        limit: this.limit,
        keyword: this.keyword
      }
      getlistlesson(info).then(res => {
        this.count = res.result.count
        if (this.count === 0) {
          this.is_noway = true
        }
        this.lessonArr = res.result.list
      })
    },
    back() {
      this.$router.go(-1)
    },
    go_seach() {
      this.$router.push({
        path: '/search'
      })
    },
    go_course(id) {
      this.$router.push({
        path: '/home',
        query: {
          lesson_id: id
        }
      })
    },
    go_back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.container{
  overflow: hidden;
}
.search_nav{
    height: 80px;
    width: 100%;
    background: #fff;
    overflow: hidden;
    .s_inp{
      width: 60%;
      height: 50px;
      margin-top: 15px;
      margin-left: 20px;
      float: left;
      background:#e8e8e8;
      border-radius: 10px;
      img{
        width: 30px;
        float: left;
        margin-left: 20px;
        margin-top: 11px;
      }
      .s_btn{
        width: 15%;
        text-align: center;
        float: left;
        line-height: 50px;
      }
      input{
        background:#e8e8e8;
        border: none;
        float: left;
        margin-left: 20px;
        height: 50px;
        width: 70%;
        outline: none;
      }
      input[type=search] {
        -webkit-appearance: textfield;
        -webkit-box-sizing: content-box;
        font-family: inherit;
        font-size: 100%;
        }
        input::-webkit-search-decoration,
        input::-webkit-search-cancel-button {
        display: none;
        }
    }
    .go_back {
      float: left;
      width: 68px;
      height: 68px;
      margin-left: 10px;
      margin-top: 6px;
    }
    .ss_btn{
      float: left;
      width: 13%;
      text-align: center;
      height: 50px;
      margin-top:15px;
      line-height: 50px;
    }
  }
.hei{
  height: 100px;
}
.all_text{
  font-size: 32px;
}
.page_header{
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #ddd;
    padding: 0 25px 0 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
        font-size: 34px;
        font-weight: 600;
    }
    .arrow_left{
      width: 22px;
      height: 44px;
    }
    .more_icon{
      width: 42px;
      height: 30px;
      margin-right: 80px;
    }
}
.res_box{
  height: calc(100vh - 100px);
  overflow: scroll;
  // margin-top: 80px;
  .no_res{
    width: 100%;
    margin-top: 200px;
    line-height: 50px;
    text-align: center;
    img{
      width: 292px;
      height: 292px;
    }
    p{
       color: #999;
      margin-top: 66px;
      text-align: center;
    }
  }
}
.item_lesson{
    display: flex;
    align-items: center;
    padding: 0px 36px;
    height: 195px;
    border-bottom: 1px solid #ececec;
    .l_img{
      width: 240px;
      height: 150px;
      float: left;
      margin-right: 20px;
    }
    .r_msg{
      flex:1;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title{
        font-size: 28px;
        font-weight: bold;
      }
      .cate{
        display: flex;
        align-items: center;
        .r{
          margin-left: 10px;
        }
        .l,.r{
          display: flex;
          align-items: center;
          color: #909090;
          img{
            margin-right: 5px;
          }
        }
      }
    }
  }
  .search_btn{
    background: #ee2e2e;
    color: #fff;
    border-radius: 0.08rem;
  }
</style>
